import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectDto } from 'shared';
import { DataSharingService } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'project-info',
    templateUrl: './edit-project-info.component.html',
    styleUrls: ['./edit-project-info.component.scss'],
    standalone: false
})
export class EditProjectInfoComponent implements OnInit {

  @Input('project') project!:ProjectDto;

  projectForm!: UntypedFormGroup;

  public color: ThemePalette = 'primary';
  public listColors = ['primary', 'accent', 'warn'];

  errorMessage!: string;
  _db!: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    //private route: ActivatedRoute,
    private router: Router,
    //private projectService: ProjectService,
    private tenantService: TenantService,
    private dataSharingService: DataSharingService,
    public translate: TranslateService,
    private oauthService: OAuthServiceService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {    
    // localStorage.setItem('dbname', this.project.name);
    // localStorage.setItem('tenant-db', this.project.tenantName);
    this.buildProjectForm(this.project);

    this.dataSharingService.passactiveProjectName(this.project.name);

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((role: string) => {
            if (role === 'admin') {
              this._db = role;
            }
          });
        }
      }
    });
  }

  buildProjectForm(projectDto: ProjectDto) {
    this.projectForm = this.formBuilder.group({
      id: [projectDto.id],
      display_name: [projectDto.display_Name],
      name: [projectDto.name],
      url: [projectDto.url],
      // latitude: [projectDto.latitude],
      // longitude: [projectDto.longitude],
      description: [projectDto.description],
      // color: [projectDto.color]
    });
  }

  editProjectInfo() {
    if (this.projectForm.valid) {
      let projectDto = new ProjectDto;

      projectDto.id = this.projectForm.value.id;
      projectDto.name = this.projectForm.value.name;
      // projectDto.longitude = this.projectForm.value.longitude;
      // projectDto.latitude = this.projectForm.value.latitude;
      projectDto.description = this.projectForm.value.description;
      projectDto.url = this.projectForm.value.url;
      // projectDto.color = this.projectForm.value.color;
      projectDto.display_Name = this.project.display_Name;

      this.updateInTenantDb(projectDto);
    }
  }
  
  updateInTenantDb(projectDto: ProjectDto) {
    let db:string = this.tenantService.currentTenantName;

    console.log("----------> edit-project-info: projectDto after update", projectDto)

    this.tenantService.updateProject(projectDto, db).subscribe({
      next: (data: any) => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${projectDto.display_Name} - ${this.translate.data["PROJECTUPDATED"]} `);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["UPDATEPROJECTERROR"]} - ${projectDto.display_Name}`)
    });
  }

  cancel() {
    this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-projects']);
  }
}